import { useNavigate } from "react-router-dom";
import {
    FaHeart,
    FaShoppingCart,
    FaStar,
} from "react-icons/fa";
import getImageUrl from "../../../../utils/imageUrl";
import "./FavoriteCard.css";

function FavoriteCard({

    favorite,

    onRemove,

}) {

    const navigate = useNavigate();

    const food = favorite.foodId;

    if (!food) return null;

   const image =
    getImageUrl(food.image) ||
    "/images/food-placeholder.png";
    return (

  <div className="favorite-card">

            {/* Food Image */}

            <div className="favorite-image">

                <img
    src={image}
    alt={food.foodName || "Food"}
    onError={(e) => {
        e.currentTarget.src =
            "/images/food-placeholder.png";
    }}
/>

            </div>

            {/* Content */}

            <div className="favorite-content">

                <h3>

                    {food.foodName}

                </h3>

                <p>

                    {food.providerId?.businessName || "HomeFoods"}

                </p>

                <div className="favorite-rating">

                    <FaStar />

                    <span>

                        {food.rating || "4.5"}

                    </span>

                </div>

                <div className="favorite-price">

                    ₹{food.price}

                </div>

                {/* Buttons */}

                <div className="favorite-actions">

    <button
        className="place-order-btn"
        onClick={() =>
            navigate(`/food/${food._id}`)
        }
    >
        <FaShoppingCart />
        Place Order
    </button>

    <button
        className="remove-btn"
        onClick={() =>
            onRemove(food._id)
        }
    >
        <FaHeart />
        Remove
    </button>

</div>
            </div>

        </div>

    );

}

export default FavoriteCard;